var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import { fetchData, getCSRFToken } from './base';
export function fetchUserAccessPage(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/visits/user_access_pages',
            params
        });
    });
}
export function fetchReportMonthStats() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/report_month_stats'
        });
    });
}
export function fetchReportSummaryStats() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/report_summary_stats'
        });
    });
}
export function fetchReportUserRegister(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/sales/user_registration',
            params
        });
    });
}
export function fetchReportDailyStats(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/sales/monthly/detail',
            params
        });
    });
}
export function fetchReportSaleMonthly(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/sales/monthly',
            params
        });
    });
}
export function fetchReportUserMonthly(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/sales/users_monthly',
            params
        });
    });
}
export function fetchReportUserDailyDetail(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/sales/users_monthly/detail',
            params
        });
    });
}
export function fetchReportDauMau() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/activity/dau_mau'
        });
    });
}
export function fetchYearlyActivity(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/activity/yearly',
            params
        });
    });
}
export function fetchMonthlyActivity(params) {
    return __awaiter(this, void 0, void 0, function* () {
        // await new Promise((resolve) => setTimeout(resolve, 50000)); // simulate delay
        return yield fetchData({
            endpoint: '/api/activity/monthly',
            params
        });
    });
}
export function fetchRecommendStats(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/recommends/stats',
            params
        });
    });
}
export function fetchUserPaidReturn(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/activity/paid_return',
            params
        });
    });
}
export function fetchCancelPayment(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/sales/user_cancel_chart',
            params
        });
    });
}
export function fetchUserTracficSource(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/sales/traffic_source',
            params
        });
    });
}
export function fetchUserTransferRating(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/sales/user_transfer_rating',
            params
        });
    });
}
export function fetchVisitStats(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/visits/stats',
            params
        });
    });
}
export function fetchVisitTopPages(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/visits/top_pages',
            params
        });
    });
}
export function fetchUserSaleData(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/sales/user_sales_data',
            params
        });
    });
}
export function fetchLTVUsers(params) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const apiParams = params ? _objectSpread(_objectSpread({}, params), {}, {
            per_page: (_b = (_a = params.limit) !== null && _a !== void 0 ? _a : params.per_page) !== null && _b !== void 0 ? _b : 20
        }) : undefined;
        return yield fetchData({
            endpoint: '/api/user_ltv',
            params: apiParams
        });
    });
}
export function formatLtvAsyncExportMessage(rowCount, email) {
    return [`${rowCount.toLocaleString()}件のデータがあるため、システムによりCSVファイルの作成処理が開始されました。`, `完了後、${email} あてにメールで自動送信されます。`, 'しばらくお待ちください。'].join('\n');
}
function parseContentDispositionFilename(header) {
    if (!header)
        return undefined;
    const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match)
        return decodeURIComponent(utf8Match[1]);
    const quotedMatch = header.match(/filename="([^"]+)"/i);
    if (quotedMatch)
        return quotedMatch[1];
    const plainMatch = header.match(/filename=([^;]+)/i);
    if (plainMatch)
        return plainMatch[1].trim();
    return undefined;
}
function defaultCsvFilename() {
    const now = new Date();
    const pad = n => String(n).padStart(2, '0');
    return `user_sales_${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${now.getTime()}.csv`;
}
export function exportLTVUsersSelected(params) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        const body = JSON.stringify({
            sex: params.sex,
            email: params.email,
            recipient_email: params.recipient_email,
            sort_by: params.sort_by,
            order: params.order,
            user_ids: params.user_ids
        });
        const res = yield fetch('/api/user_ltv/export', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'text/csv, application/json',
                'X-CSRF-Token': (_a = getCSRFToken()) !== null && _a !== void 0 ? _a : ''
            },
            body
        });
        if (!res.ok) {
            const errorText = yield res.text();
            let message = 'CSVのエクスポートに失敗しました。';
            try {
                const json = JSON.parse(errorText.trim());
                if (json.msg)
                    message = json.msg;
            }
            catch (_f) {
                // keep default message
            }
            throw new Error(message);
        }
        const contentDisposition = res.headers.get('Content-Disposition');
        const text = yield res.text();
        const trimmed = text.trim();
        if (trimmed.startsWith('{')) {
            const json = JSON.parse(trimmed);
            if (json.async) {
                return {
                    type: 'email',
                    row_count: (_b = json.row_count) !== null && _b !== void 0 ? _b : 0,
                    email: (_c = json.email) !== null && _c !== void 0 ? _c : '',
                    message: (_d = json.message) !== null && _d !== void 0 ? _d : 'export_queued_email'
                };
            }
            if (json.success === false || json.msg) {
                throw new Error(json.msg || 'CSVのエクスポートに失敗しました。');
            }
        }
        return {
            type: 'download',
            blob: new Blob([text], {
                type: 'text/csv;charset=utf-8'
            }),
            filename: (_e = parseContentDispositionFilename(contentDisposition)) !== null && _e !== void 0 ? _e : defaultCsvFilename()
        };
    });
}
export function fetchAdminSurveys(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/admins/surveys',
            params
        });
    });
}
export function fetchAdminUserList(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/admins/users',
            params
        });
    });
}
export function fetchAdminRankRequestPendingList(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/admins/users/rank_request_pending',
            params: params !== null && params !== void 0 ? params : {}
        });
    });
}
export function updateAdminUserDiagnosisResult(userId, sexual_desire_diagnosis_result_id) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: `/api/users/${userId}/diagnosis_result`,
            options: {
                method: 'PATCH',
                body: JSON.stringify({
                    sexual_desire_diagnosis_result_id
                })
            }
        });
    });
}
export function fetchAdminUserStatistics(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/admins/users/statistics',
            params: params !== null && params !== void 0 ? params : {}
        });
    });
}
export function fetchAdminFemaleNoMatchUsers(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/admins/users/no_match_by_category',
            params
        });
    });
}
export function fetchAdminAdBanners(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/ad_banners',
            params
        });
    });
}
const buildAdBannerFormData = params => {
    var _a, _b, _c, _d, _e, _f;
    const formData = new FormData();
    formData.append('ad_banner[title]', params.title);
    formData.append('ad_banner[media_type]', params.media_type);
    formData.append('ad_banner[position]', String(params.position));
    formData.append('ad_banner[sort_order]', String((_a = params.sort_order) !== null && _a !== void 0 ? _a : 0));
    formData.append('ad_banner[active]', String((_b = params.active) !== null && _b !== void 0 ? _b : true));
    formData.append('ad_banner[image_link_url]', (_c = params.image_link_url) !== null && _c !== void 0 ? _c : '');
    formData.append('ad_banner[video_link_url]', (_d = params.video_link_url) !== null && _d !== void 0 ? _d : '');
    formData.append('ad_banner[start_date]', (_e = params.start_date) !== null && _e !== void 0 ? _e : '');
    formData.append('ad_banner[end_date]', (_f = params.end_date) !== null && _f !== void 0 ? _f : '');
    if (params.banner_image) {
        formData.append('ad_banner[banner_image]', params.banner_image);
    }
    if (params.banner_video) {
        formData.append('ad_banner[banner_video]', params.banner_video);
    }
    return formData;
};
export function createAdBanner(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const formData = buildAdBannerFormData(params);
        return yield fetchData({
            endpoint: '/api/ad_banners',
            options: {
                method: 'POST',
                body: formData
            },
            isFormdata: true
        });
    });
}
export function updateAdBanner(id, params) {
    return __awaiter(this, void 0, void 0, function* () {
        const formData = buildAdBannerFormData(params);
        return yield fetchData({
            endpoint: `/api/ad_banners/${id}`,
            options: {
                method: 'PATCH',
                body: formData
            },
            isFormdata: true
        });
    });
}
export function deleteAdBanner(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: `/api/ad_banners/${id}`,
            options: {
                method: 'DELETE'
            }
        });
    });
}
export function updateAdBannerSortOrder(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/ad_banners/update_sort_order',
            options: {
                method: 'UPDATE',
                body: JSON.stringify(params)
            }
        });
    });
}
export function fetchAdminDiagnosisIcons(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/sexual_desire_diagnosis_results',
            params
        });
    });
}
const buildDiagnosisIconFormData = params => {
    var _a, _b, _c;
    const formData = new FormData();
    formData.append('sexual_desire_diagnosis_result[title]', params.title);
    formData.append('sexual_desire_diagnosis_result[description]', (_a = params.description) !== null && _a !== void 0 ? _a : '');
    formData.append('sexual_desire_diagnosis_result[sort_order]', String((_b = params.sort_order) !== null && _b !== void 0 ? _b : 0));
    formData.append('sexual_desire_diagnosis_result[active]', String((_c = params.active) !== null && _c !== void 0 ? _c : true));
    if (params.image) {
        formData.append('sexual_desire_diagnosis_result[image]', params.image);
    }
    return formData;
};
export function createDiagnosisIcon(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const formData = buildDiagnosisIconFormData(params);
        return yield fetchData({
            endpoint: '/api/sexual_desire_diagnosis_results',
            options: {
                method: 'POST',
                body: formData
            },
            isFormdata: true
        });
    });
}
export function updateDiagnosisIcon(id, params) {
    return __awaiter(this, void 0, void 0, function* () {
        const formData = buildDiagnosisIconFormData(params);
        return yield fetchData({
            endpoint: `/api/sexual_desire_diagnosis_results/${id}`,
            options: {
                method: 'PATCH',
                body: formData
            },
            isFormdata: true
        });
    });
}
export function updateDiagnosisIconSortOrder(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/sexual_desire_diagnosis_results/update_sort_order',
            options: {
                method: 'POST',
                body: JSON.stringify(params)
            }
        });
    });
}
export function fetchAdminRankingLevels(options) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const params = {
            order_direction: (_a = options === null || options === void 0 ? void 0 : options.order_direction) !== null && _a !== void 0 ? _a : 'desc'
        };
        if (options === null || options === void 0 ? void 0 : options.include_inactive) {
            params.include_inactive = 'true';
        }
        return yield fetchData({
            endpoint: '/api/ranking_levels',
            params
        });
    });
}
const buildRankingLevelFormData = params => {
    var _a, _b;
    const formData = new FormData();
    if (params.code !== undefined) {
        formData.append('ranking_level[code]', params.code);
    }
    formData.append('ranking_level[name]', params.name);
    formData.append('ranking_level[description]', (_a = params.description) !== null && _a !== void 0 ? _a : '');
    formData.append('ranking_level[active]', String((_b = params.active) !== null && _b !== void 0 ? _b : true));
    if (params.order !== undefined) {
        formData.append('ranking_level[order]', String(params.order));
    }
    if ('insert_position' in params && params.insert_position) {
        formData.append('ranking_level[insert_position]', params.insert_position);
    }
    if (params.requires_sti_before_rank_up !== undefined) {
        formData.append('ranking_level[requires_sti_before_rank_up]', String(params.requires_sti_before_rank_up));
    }
    if (params.auto_evaluate_enabled !== undefined) {
        formData.append('ranking_level[auto_evaluate_enabled]', String(params.auto_evaluate_enabled));
    }
    if (params.image) {
        formData.append('ranking_level[image]', params.image);
    }
    return formData;
};
export function createAdminRankingLevel(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const formData = buildRankingLevelFormData(params);
        return yield fetchData({
            endpoint: '/api/ranking_levels',
            options: {
                method: 'POST',
                body: formData
            },
            isFormdata: true
        });
    });
}
export function updateAdminRankingLevel(id, params) {
    return __awaiter(this, void 0, void 0, function* () {
        const formData = buildRankingLevelFormData(params);
        return yield fetchData({
            endpoint: `/api/ranking_levels/${id}`,
            options: {
                method: 'PATCH',
                body: formData
            },
            isFormdata: true
        });
    });
}
export function fetchAdminNewRankConditions(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: `/api/ranking_levels/${params.ranking_level_id}/new_rank_conditions`,
            params: params.include_inactive ? {
                include_inactive: 'true'
            } : undefined
        });
    });
}
export function fetchAdminNewRankConditionEvaluationKeys(rankingLevelCode) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/new_rank_conditions/evaluation_keys',
            params: {
                ranking_level_code: rankingLevelCode
            }
        });
    });
}
export function createAdminNewRankCondition(rankingLevelId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: `/api/ranking_levels/${rankingLevelId}/new_rank_conditions`,
            options: {
                method: 'POST',
                body: JSON.stringify({
                    new_rank_condition: params
                })
            }
        });
    });
}
export function updateAdminNewRankCondition(id, params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: `/api/new_rank_conditions/${id}`,
            options: {
                method: 'PATCH',
                body: JSON.stringify({
                    new_rank_condition: params
                })
            }
        });
    });
}
export function updateAdminNewRankConditionSortOrder(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/new_rank_conditions/update_sort_order',
            options: {
                method: 'POST',
                body: JSON.stringify(params)
            }
        });
    });
}
export function fetchUserAgeDistribution(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/statistics/user_age_distribution',
            params
        });
    });
}
export function fetchUserAgeDistributionDetail(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/statistics/user_age_distribution/detail',
            params
        });
    });
}
export function fetchUserRegionDistribution(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/statistics/user_region_distribution',
            params
        });
    });
}
export function fetchUserPrefectureDistribution(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/statistics/user_prefecture_distribution',
            params
        });
    });
}
export function fetchUserRegionDistributionDetail(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/statistics/user_region_distribution/detail',
            params
        });
    });
}
export function fetchRecommendMatchByAge(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/statistics/recommend_match_by_age',
            params
        });
    });
}
export function fetchRecommendMatchByAgeDetail(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/statistics/recommend_match_by_age/detail',
            params
        });
    });
}
export function fetchReviewSatisfaction(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/statistics/review_satisfaction',
            params
        });
    });
}
export function fetchReviewSatisfactionDetail(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/statistics/review_satisfaction/detail',
            params
        });
    });
}
export function fetchFemaleNoMatchReasons(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/statistics/female_no_match_reasons',
            params
        });
    });
}
export function fetchFemaleNoMatchReasonsDetail(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/statistics/female_no_match_reasons/detail',
            params
        });
    });
}
export function fetchMaleLikesPerMonth(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/statistics/male_likes_per_month',
            params
        });
    });
}
export function fetchMaleLikesPerMonthDetail(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/statistics/male_likes_per_month/detail',
            params
        });
    });
}
export function fetchStiDocumentSubmissions(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/sti_document_submissions',
            params: params
        });
    });
}
export function fetchStiDocumentSubmission(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: `/api/sti_document_submissions/${id}`
        });
    });
}
export function fetchStiDocumentUserHistory(userId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: `/api/users/${userId}/sti_document_submissions`,
            params: params
        });
    });
}
export function approveStiDocumentSubmission(id, expiresAt) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: `/api/sti_document_submissions/${id}/approve`,
            options: {
                method: 'POST',
                body: JSON.stringify({
                    expires_at: expiresAt
                })
            }
        });
    });
}
export function rejectStiDocumentSubmission(id, rejectionReason) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: `/api/sti_document_submissions/${id}/reject`,
            options: {
                method: 'POST',
                body: JSON.stringify({
                    rejection_reason: rejectionReason
                })
            }
        });
    });
}
